import { encodeParam } from "utilities/misc";
import { get, post } from "utilities/network";

export const httpFetchUsers = (
  limit: number,
  page: number,
  order: string = "A-Z",
) => {
  return get(
    `support/users?limit=${encodeParam(limit)}&page=${encodeParam(page)}&order=${encodeParam(order)}`,
  );
};

export const httpUserBalances = (userID: string) => {
  return get(`support/balances/user/${encodeParam(userID)}`);
};

export const httpUserWallet = (userID: string) => {
  return get(`support/users/userWallet/${encodeParam(userID)}`);
};

export const httpUserRevenue = (
  id: string,
  type: string,
  date: Date | string,
) => {
  return get(
    `support/users/revenue/${encodeParam(id)}?date=${encodeParam(date)}&type=${encodeParam(type)}`,
  );
};

export const httpUserTransactionAnalytics = (
  id: string,
  type: string,
  date: Date | string,
) => {
  return get(
    `support/users/transactionAnalytics/${encodeParam(id)}?date=${encodeParam(date)}&type=${encodeParam(type)}`,
  );
};

export const httpAcquisitions = (type: string, date: Date | string) => {
  return get(
    `support/analytics/acquisitions?date=${encodeParam(date)}&type=${encodeParam(type)}`,
  );
};

export const httpUserTransactions = (
  id: string,
  currencyType: string,
  transactionType: string,
  place: string,
  limit: number = 50,
  page: number = 1,
) => {
  return get(
    `support/users/transactions/${encodeParam(id)}?transactionType=${encodeParam(transactionType)}&place=${encodeParam(place)}&currencyType=${encodeParam(currencyType)}&limit=${encodeParam(limit)}&page=${encodeParam(page)}`,
  );
};

export const httpUSearchUser = (userName: string, signal?: AbortSignal) => {
  return get(`support/users/search?search=${encodeParam(userName)}`, signal);
};

export const httpFetchAddressVerificationReviews = (
  status: string,
  limit: number = 20,
  page: number = 1,
) =>
  get(
    `support/users/addressVerificationReviews?status=${encodeParam(status)}&limit=${encodeParam(limit)}&page=${encodeParam(page)}`,
  );

export const httpGetAddressVerificationReview = (id: number) =>
  get(`support/users/addressVerificationReviews/${encodeParam(id)}`);

export const httpDecideAddressVerification = (
  id: number,
  decision: "approve" | "reject",
  reason: string,
  verificationId: string,
  reviewRevision: string,
) =>
  post(
    `support/users/addressVerificationReviews/${encodeParam(id)}/${decision}`,
    {
      reason,
      verificationId,
      reviewRevision,
    },
  );
